import { render, staticRenderFns } from "./ModalAlertWarningNoti.vue?vue&type=template&id=4dda6ae8&scoped=true&"
import script from "./ModalAlertWarningNoti.vue?vue&type=script&lang=js&"
export * from "./ModalAlertWarningNoti.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlertWarningNoti.vue?vue&type=style&index=0&id=4dda6ae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dda6ae8",
  null
  
)

export default component.exports